import React, {useContext, Fragment} from 'react';
import {ConfigurationContext} from '../../Context/Configuration';
import Layout from '../LayoutHorizontalTwo/LayoutHorizontalTwo';
import {Section1,  Section3} from '../Sections/Section';
import NonVRSiteGridItem from '../NonVRSiteGridItem/NonVRSiteGridItem'

const HomeGrid=()=>{
	const [config, update]=useContext(ConfigurationContext);
	return (
		<Fragment>
			<div style={{width:'100%',maxWidth:'1150px',margin:'0 auto'}}>
				<NonVRSiteGridItem/>
				<Section1 details={config.pageBox2[0]}/>
				<Layout layout3={true}>
						{
						config.pageBox3.map((elem,index)=>(
						(
						
						<Section3 key={index} details={elem}/>

						)))
						
						}
				</Layout>
			</div>
		</Fragment>
	);
}

export default HomeGrid;